import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Traductor from "@utils/traductor";
import { LANGUAGE } from "@/constants";
import Corporation from "@components/Corporation";
import Button from "@mui/material/Button";
import theme from "@/theme";

const traductor = new Traductor(LANGUAGE);

export const DashboardHeader = ({
  name = "",
  place = "",
  corporation = "",
  table = "",
  corporationFixed = false,
  hasMultiplesTables = false,
  onCorporationChange,
  onSwitchTable,
}) => {
  return (
    <Box
      sx={{
        marginTop: "30px",
        marginBottom: "30px",
        paddingLeft: "5px",
        paddingRigth: "5px",
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Box>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <Typography
                sx={{
                  color: theme.palette.dashbaord.header,
                  fontWeight: "bold",
                }}
                variant="button"
                display="block"
                gutterBottom
              >
                {traductor.translate("witness")}:
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                sx={{ paddingLeft: "5px" }}
                variant="caption"
                display="block"
                gutterBottom
              >
                {name}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <Typography
                sx={{
                  color: theme.palette.dashbaord.header,
                  fontWeight: "bold",
                }}
                variant="button"
                display="block"
                gutterBottom
              >
                {traductor.translate("place")}:
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                sx={{ paddingLeft: "5px" }}
                variant="caption"
                display="block"
                gutterBottom
              >
                {place}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <Typography
                sx={{
                  color: theme.palette.dashbaord.header,
                  fontWeight: "bold",
                }}
                variant="button"
                display="block"
                gutterBottom
              >
                {traductor.translate("corporation")}:
              </Typography>
            </Grid>

            <Grid item>
              {corporationFixed ? (
                <Typography
                  sx={{ paddingLeft: "5px" }}
                  variant="caption"
                  display="block"
                  gutterBottom
                >
                  {corporation}
                </Typography>
              ) : (
                <Box sx={{ paddingLeft: "5px" }}>
                  <Corporation
                    onChange={onCorporationChange}
                    defaultOption={corporation}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            width: "60px",
            textalign: "center",
          }}
        >
          <Button
            variant="text"
            disabled={!hasMultiplesTables || corporationFixed}
            onClick={onSwitchTable}
          >
            <Typography
              sx={{
                fontSize: "40px",
                marginBottom: "0px",
                textAlign: "center",
              }}
              variant="caption"
              display="block"
              gutterBottom
            >
              {table}
            </Typography>
          </Button>

          <Typography
            sx={{
              color: theme.palette.dashbaord.header,
              textAlign: "center",
              fontSize: "12px",
            }}
            variant="button"
            display="block"
            gutterBottom
          >
            {traductor.translate("table")}
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
};
